import { InjectionToken } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

/**
 * The unwrapped ngx-cookie-service, for CustomCookieService to delegate to.
 *
 * It lives in its own file rather than in app.module because
 * custom-cookie-service.ts needs it: importing it from app.module made the two
 * files a cycle, which the app build tolerated but the spec bundle did not
 * ("Cannot access 'CustomCookieService' before initialization", thrown at load
 * and taking the run's exit code with it).
 */
export const RAW_COOKIE_SERVICE = new InjectionToken<CookieService>(
  'RAW_COOKIE_SERVICE',
);
